// extracted by mini-css-extract-plugin
export default {"slider":"PoemList_slider__Qt9Df","block":"PoemList_block__VfJjC","info":"PoemList_info__zP1L-","infoWrap":"PoemList_infoWrap__q-kbr","link":"PoemList_link__tJ9E7"};